'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _input = require('antd/lib/input');

var _input2 = _interopRequireDefault(_input);

require('antd/lib/input/style');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InputWidget = function InputWidget(props) {
  return _react2.default.createElement(_input2.default, {
    type: 'text',
    placeholder: props.placeholder,
    value: props.value,
    required: props.required,
    disabled: props.disabled,
    onChange: function onChange(event) {
      return props.onChange(event.target.value);
    }
  });
};

InputWidget.defaultProps = {
  value: '',
  placeholder: '',
  disabled: false
};

InputWidget.propTypes = {
  value: _propTypes2.default.string,
  placeholder: _propTypes2.default.string,
  required: _propTypes2.default.bool.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  disabled: _propTypes2.default.bool
};

exports.default = InputWidget;


//////////////////
// WEBPACK FOOTER
// ./node_modules/slide-new-toolkit/dist/Form/Widgets/InputWidget/index.js
// module id = 889
// module chunks = 0